// src/pages/capelas/Capelas.js

import React, { useEffect, useState } from 'react';
import { getCapelas } from '../../services/api';

const COMUNIDADES = [
  { id: 'matriz',     nome: 'Matriz',                             endereco: 'R. Joaquim Bezerra, 235 – Messejana' },
  { id: 'menino',    nome: 'Menino Jesus',                       endereco: 'Messejana – Fortaleza, CE' },
  { id: 'teresinha', nome: 'Santa Teresinha',                    endereco: 'Messejana – Fortaleza, CE' },
  { id: 'fatima',    nome: 'Nossa Senhora de Fátima – Canaã',    endereco: 'Canaã – Fortaleza, CE' },
  { id: 'gracas',    nome: 'Nossa Senhora das Graças – Paupina', endereco: 'Paupina – Fortaleza, CE' },
];

const PASTORAIS = [
  { icon: '👨‍👩‍👧‍👦', sigla: 'PASFAM', nome: 'Pastoral Familiar',              desc: 'Acompanha e fortalece as famílias da paróquia, promovendo encontros, retiros e momentos de reflexão sobre o amor conjugal e a vida em família à luz do Evangelho.' },
  { icon: '📢', sigla: 'PASCOM', nome: 'Pastoral de Comunicação',          desc: 'Responsável pela comunicação e evangelização nos meios digitais e impressos, levando a Boa Nova a toda a comunidade paroquial e além.' },
  { icon: '📖', sigla: '',       nome: 'Catequese',                         desc: 'Formação na fé para todas as idades: Batismo de adultos, catequese infantil, juvenil e de adultos, preparando os fiéis para os sacramentos da iniciação cristã.' },
  { icon: '✝️', sigla: '',       nome: 'Pastoral da Liturgia',              desc: 'A Pastoral da Liturgia tem a missão de preparar e animar as celebrações, ajudando toda a comunidade a viver a fé com mais beleza, organização e espiritualidade. Se você deseja colocar seus dons a serviço da Igreja e participar deste ministério, será uma alegria acolhê-lo(a)!' },
  { icon: '🎵', sigla: '',       nome: 'Pastoral da Música',                desc: 'Anima as celebrações litúrgicas por meio do canto e da música sacra, formando corais e grupos de louvor que elevam os corações a Deus.' },
  { icon: '🤗', sigla: '',       nome: 'Pastoral do Acolhimento',           desc: 'Recebe e integra os fiéis nas comunidades, criando um ambiente de fraternidade, pertencimento e cuidado para que todos se sintam em casa.' },
  { icon: '🌿', sigla: '',       nome: 'Pastoral Vida Plena',               desc: 'Dedicada ao acolhimento e cuidado dos idosos, promovendo encontros de espiritualidade, lazer e saúde para que vivam com alegria e dignidade.' },
  { icon: '🙏', sigla: '',       nome: 'Pastoral do Dízimo',                desc: 'A Pastoral do Dízimo é o grupo da Igreja que conscientiza os fiéis sobre a importância  da partilha Espiritual e financeira do dízimo.' },
  { icon: '⛪', sigla: '',       nome: 'Coroinhas e Cerimoniários',         desc: 'Formação e animação dos jovens que servem no altar, auxiliando os celebrantes e participando ativamente das celebrações litúrgicas da paróquia.' },
  { icon: '🫶', sigla: 'MESC',  nome: 'Ministros Extraordinários da Sagrada Comunhão', desc: 'Ministros formados para distribuir a Sagrada Eucaristia durante as missas e levar a comunhão aos doentes e impossibilitados de comparecer à igreja.' },
  { icon: '📣', sigla: 'MEPA',  nome: 'Ministros Extraordinários da Palavra', desc: 'Proclamam a Palavra de Deus nas celebrações litúrgicas, auxiliam em celebrações da Palavra e atuam na evangelização dentro e fora da paróquia.' },
];

const MOVIMENTOS = [
  { icon: '📿', nome: 'Terço dos Homens',                    desc: 'Grupo de homens que se reúnem para rezar o Santo Terço, fortalecendo a fé, a família e a comunhão fraterna entre os fiéis do sexo masculino.' },
  { icon: '💛', nome: 'Mães que Oram pelos Filhos',          desc: 'Grupo de mães que se encontram regularmente para interceder pelos filhos em oração, confiando-os à proteção de Nossa Senhora e ao amor de Deus.' },
  { icon: '❤️', nome: 'Apostolado da Oração',                desc: 'Movimento mundial que une os fiéis em oração pelas intenções do Papa e da Igreja, consagrando cada dia ao Sagrado Coração de Jesus.' },
  { icon: '💙', nome: 'Legião de Maria',                     desc: 'Associação de fiéis leigos que, sob a direção de Maria, dedicam-se ao apostolado, à visita aos doentes, às famílias e à evangelização.' },
  { icon: '🌟', nome: 'Grupo de Jovens Civilização do Amor', desc: 'Somos um grupo de jovens que desejam se aproximar cada vez mais de Deus e crescer na busca pela santidade. A partir de temas do cotidiano e da realidade dos jovens, promovemos momentos de reflexão, partilha e vivência da fé, buscando levar o Evangelho para a vida concreta. Vem com a gente ser parte da caminhada rumo a construção da civilização do amor!' },
  { icon: '💍', nome: 'Encontro de Casais com Cristo (ECC)', desc: 'O Encontro de Casais com Cristo (ECC) é um serviço da Igreja Católica que evangeliza e fortalece a vida conjugal e familiar por meio da oração, da formação e da convivência fraterna. Venha conhecer o ECC e caminhar conosco na missão de construir famílias firmes na fé e no amor de Cristo.' },
];

/* ── Modal da Comunidade ─────────────────────────────────────────── */
const ModalComunidade = ({ capela, onClose }) => {
  const [imgErro, setImgErro] = useState(false);

  // Fechar com ESC
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handler);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const fotos = [
    chapel => chapel.foto,
    chapel => chapel.foto2,
    chapel => chapel.foto3,
  ].map(fn => fn(capela)).filter(Boolean);

  const [fotoAtiva, setFotoAtiva] = useState(0);

  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: 'fixed', inset: 0, zIndex: 2000,
        background: 'rgba(10,20,40,0.85)',
        backdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 'var(--space-md)',
        overflowY: 'auto',
      }}
    >
      <div style={{
        background: 'var(--white)',
        borderRadius: 'var(--radius-xl)',
        width: '100%',
        maxWidth: 680,
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
        position: 'relative',
      }}>
        {/* Botão fechar */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute', top: 12, right: 12, zIndex: 10,
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(0,0,0,0.5)', border: 'none',
            color: 'var(--white)', fontSize: '1rem',
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
            backdropFilter: 'blur(4px)',
          }}
        >✕</button>

        {/* Foto principal */}
        <div style={{
          height: 260, background: 'linear-gradient(135deg, var(--navy-dark), var(--navy))',
          borderRadius: 'var(--radius-xl) var(--radius-xl) 0 0',
          overflow: 'hidden', position: 'relative',
        }}>
          {fotos.length > 0 && !imgErro ? (
            <>
              <img
                src={fotos[fotoAtiva]}
                alt={capela.nome}
                onError={() => setImgErro(true)}
                style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }}
              />
              {/* Navegação de fotos */}
              {fotos.length > 1 && (
                <>
                  <button
                    onClick={e => { e.stopPropagation(); setFotoAtiva(prev => (prev - 1 + fotos.length) % fotos.length); }}
                    style={{
                      position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)',
                      background: 'rgba(0,0,0,0.55)', border: 'none', color: 'white',
                      width: 38, height: 38, borderRadius: '50%', cursor: 'pointer',
                      fontSize: '1.4rem', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      backdropFilter: 'blur(4px)', zIndex: 2, lineHeight: 1,
                    }}>‹</button>
                  <button
                    onClick={e => { e.stopPropagation(); setFotoAtiva(prev => (prev + 1) % fotos.length); }}
                    style={{
                      position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
                      background: 'rgba(0,0,0,0.55)', border: 'none', color: 'white',
                      width: 38, height: 38, borderRadius: '50%', cursor: 'pointer',
                      fontSize: '1.4rem', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      backdropFilter: 'blur(4px)', zIndex: 2, lineHeight: 1,
                    }}>›</button>
                  <div style={{ position: 'absolute', bottom: 12, left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: '0.5rem', zIndex: 2 }}>
                    {fotos.map((_, i) => (
                      <button key={i} onClick={e => { e.stopPropagation(); setFotoAtiva(i); }} style={{
                        width: i === fotoAtiva ? 24 : 8, height: 8,
                        borderRadius: 4, border: 'none', cursor: 'pointer',
                        background: i === fotoAtiva ? 'var(--gold)' : 'rgba(255,255,255,0.7)',
                        transition: 'all 0.2s', padding: 0,
                      }} />
                    ))}
                  </div>
                </>
              )}
            </>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
              <span style={{ fontSize: '4rem', opacity: 0.2 }}>⛪</span>
            </div>
          )}
          {/* Faixa do nome */}
          <div style={{
            position: 'absolute', bottom: 0, left: 0, right: 0,
            background: 'linear-gradient(to top, rgba(10,20,40,0.9), transparent)',
            padding: '2rem 1.5rem 1rem',
          }}>
            <h2 style={{ color: 'var(--white)', margin: 0, fontSize: 'clamp(1.1rem, 3vw, 1.5rem)', lineHeight: 1.2 }}>{capela.nome}</h2>
          </div>
        </div>

        {/* Conteúdo */}
        <div style={{ padding: 'var(--space-xl)' }}>

          {/* Endereço */}
          {capela.endereco && (
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', marginBottom: 'var(--space-lg)' }}>
              <span style={{ fontSize: '1.25rem', flexShrink: 0 }}>📍</span>
              <div>
                <p style={{ color: 'var(--gold)', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '0.2rem' }}>Endereço</p>
                <p style={{ color: 'var(--gray-600)', fontSize: '0.9rem', margin: 0 }}>{capela.endereco}</p>
              </div>
            </div>
          )}

          {/* Horários */}
          {capela.horarios && (
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', marginBottom: 'var(--space-lg)' }}>
              <span style={{ fontSize: '1.25rem', flexShrink: 0 }}>🕐</span>
              <div>
                <p style={{ color: 'var(--gold)', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '0.2rem' }}>Horários das Celebrações</p>
                <p style={{ color: 'var(--gray-600)', fontSize: '0.9rem', whiteSpace: 'pre-wrap', margin: 0, lineHeight: 1.7 }}>{capela.horarios}</p>
              </div>
            </div>
          )}

          {/* Divisor */}
          {(capela.endereco || capela.horarios) && capela.descricao && (
            <div style={{ height: 1, background: 'var(--gray-100)', margin: 'var(--space-md) 0' }} />
          )}

          {/* Descrição */}
          {capela.descricao && (
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
              <span style={{ fontSize: '1.25rem', flexShrink: 0 }}>📖</span>
              <div>
                <p style={{ color: 'var(--gold)', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '0.2rem' }}>Sobre a Comunidade</p>
                <p style={{ color: 'var(--gray-600)', fontSize: '0.9rem', lineHeight: 1.8, margin: 0 }}>{capela.descricao}</p>
              </div>
            </div>
          )}

          {/* Se não tem nenhum dado */}
          {!capela.endereco && !capela.horarios && !capela.descricao && (
            <p style={{ color: 'var(--gray-400)', textAlign: 'center', padding: 'var(--space-lg)' }}>
              Informações em breve.
            </p>
          )}

          {/* Botão fechar */}
          <button
            onClick={onClose}
            className="btn btn-navy"
            style={{ width: '100%', justifyContent: 'center', marginTop: 'var(--space-lg)' }}
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

/* ── Card da Comunidade ──────────────────────────────────────────── */
const ComunidadeCard = ({ capela, onClick }) => {
  const [imgErro, setImgErro] = useState(false);
  return (
    <div
      onClick={() => onClick(capela)}
      style={{ cursor: 'pointer', display: 'flex', textDecoration: 'none' }}
    >
      <div className="card" style={{ width: '100%', borderTop: '4px solid var(--gold)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ height: '160px', background: 'linear-gradient(135deg, var(--navy) 0%, var(--navy-light) 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', flexShrink: 0 }}>
          {(capela.foto && !imgErro) ? (
            <img src={capela.foto} alt={capela.nome}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              onError={() => setImgErro(true)} />
          ) : (
            <span style={{ fontSize: '3rem', opacity: 0.25 }}>⛪</span>
          )}
        </div>
        <div style={{ padding: 'var(--space-lg)', flex: 1, display: 'flex', flexDirection: 'column' }}>
          <h3 style={{ fontSize: '1rem', marginBottom: '0.4rem', color: 'var(--navy)', lineHeight: 1.3 }}>{capela.nome}</h3>
          {capela.endereco && <p style={{ fontSize: '0.8rem', color: 'var(--gray-400)', marginBottom: '0.5rem' }}>📍 {capela.endereco}</p>}
          {capela.descricao && (
            <p style={{ fontSize: '0.82rem', color: 'var(--gray-600)', lineHeight: 1.6, flex: 1 }}>
              {capela.descricao.length > 90 ? capela.descricao.slice(0, 90) + '...' : capela.descricao}
            </p>
          )}
          <div style={{ marginTop: '0.75rem', color: 'var(--gold)', fontSize: '0.85rem', fontWeight: 600 }}>
            Ver detalhes →
          </div>
        </div>
      </div>
    </div>
  );
};

/* ── Card de Grupo (Pastoral/Movimento) ─────────────────────────── */
const GrupoCard = ({ icon, nome, sigla, desc }) => (
  <div className="card" style={{ padding: 'var(--space-xl)', borderTop: '4px solid var(--gold)', display: 'flex', flexDirection: 'column' }}>
    <div style={{ fontSize: '2.25rem', marginBottom: '0.75rem' }}>{icon}</div>
    <div style={{ marginBottom: '0.5rem' }}>
      <h3 style={{ fontSize: '1rem', color: 'var(--navy)', display: 'inline' }}>{nome}</h3>
      {sigla && <span style={{ marginLeft: '0.5rem', fontSize: '0.72rem', background: 'var(--gold-pale)', color: 'var(--navy)', padding: '0.15rem 0.5rem', borderRadius: '99px', fontWeight: 700, verticalAlign: 'middle' }}>{sigla}</span>}
    </div>
    <p style={{ fontSize: '0.875rem', color: 'var(--gray-600)', lineHeight: 1.7, flex: 1, marginBottom: '1rem' }}>{desc}</p>
    <div style={{ borderTop: '1px solid var(--gray-200)', paddingTop: '0.75rem' }}>
      <p style={{ fontSize: '0.8rem', color: 'var(--gray-400)', margin: 0 }}>
        📱 <a href="tel:+5585981346247" style={{ color: 'var(--navy)', fontWeight: 600 }}>(85) 98134-6247</a>
        <span style={{ display: 'block', marginTop: '0.15rem' }}>Secretaria Paroquial</span>
      </p>
    </div>
  </div>
);

const SkeletonCard = () => (
  <div style={{ background: 'var(--white)', borderRadius: 'var(--radius-lg)', borderTop: '4px solid var(--gray-200)', boxShadow: 'var(--shadow-sm)', overflow: 'hidden' }}>
    <div style={{ height: 160, background: 'var(--gray-100)', animation: 'pulse 1.5s ease-in-out infinite' }} />
    <div style={{ padding: 'var(--space-lg)' }}>
      <div style={{ height: 16, width: '70%', background: 'var(--gray-100)', borderRadius: 4, marginBottom: '0.75rem', animation: 'pulse 1.5s ease-in-out infinite' }} />
      <div style={{ height: 12, background: 'var(--gray-100)', borderRadius: 4, marginBottom: '0.5rem', animation: 'pulse 1.5s ease-in-out infinite' }} />
      <div style={{ height: 12, width: '80%', background: 'var(--gray-100)', borderRadius: 4, animation: 'pulse 1.5s ease-in-out infinite' }} />
    </div>
    <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }`}</style>
  </div>
);

/* ── Página Principal ────────────────────────────────────────────── */
const Capelas = () => {
  const [capelas, setCapelas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [aba, setAba] = useState('comunidades');
  const [modalCapela, setModalCapela] = useState(null);

  useEffect(() => {
    getCapelas()
      .then(r => setCapelas(r?.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const lista = capelas.length > 0 ? capelas : COMUNIDADES;

  const tabStyle = (active) => ({
    padding: '0.875rem 1.25rem', border: 'none',
    borderBottom: active ? '3px solid var(--gold)' : '3px solid transparent',
    background: 'transparent',
    color: active ? 'var(--navy)' : 'var(--gray-400)',
    fontWeight: active ? 700 : 500, fontSize: '0.9rem',
    cursor: 'pointer', transition: 'all 0.2s',
    fontFamily: 'var(--font-body)', whiteSpace: 'nowrap', flex: 1,
  });

  return (
    <main style={{ paddingTop: '72px' }}>

      {/* Modal */}
      {modalCapela && (
        <ModalComunidade
          capela={modalCapela}
          onClose={() => setModalCapela(null)}
        />
      )}

      {/* Hero */}
      <section style={{ background: 'linear-gradient(135deg, var(--navy-dark) 0%, var(--navy) 100%)', padding: 'var(--space-2xl) var(--space-xl)', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle, rgba(201,160,48,0.07) 1px, transparent 1px)', backgroundSize: '40px 40px', pointerEvents: 'none' }} />
        <div style={{ position: 'relative' }}>
          <div className="ornament" style={{ justifyContent: 'center', marginBottom: '0.75rem' }}>Paróquia</div>
          <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>⛪</div>
          <h1 style={{ color: 'var(--white)', marginBottom: '0.5rem' }}>Comunidades e Pastorais</h1>
          <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: 520, margin: '0 auto', lineHeight: 1.8 }}>
            Conheça as comunidades, pastorais e movimentos que formam a Paróquia Nossa Senhora da Conceição.
          </p>
        </div>
      </section>

      {/* Abas */}
      <div style={{ background: 'var(--white)', borderBottom: '1px solid var(--gray-200)', position: 'sticky', top: '72px', zIndex: 100 }}>
        <div className="container" style={{ display: 'flex', overflowX: 'auto', scrollbarWidth: 'none' }}>
          <button style={tabStyle(aba === 'comunidades')} onClick={() => setAba('comunidades')}>⛪ Comunidades</button>
          <button style={tabStyle(aba === 'pastorais')}   onClick={() => setAba('pastorais')}>✝️ Pastorais</button>
          <button style={tabStyle(aba === 'movimentos')}  onClick={() => setAba('movimentos')}>🤝 Movimentos</button>
        </div>
      </div>

      {/* Conteúdo */}
      <section style={{ background: 'var(--off-white)', padding: 'var(--space-xl) var(--space-md)', minHeight: '60vh' }}>
        <div className="container">

          {aba === 'comunidades' && (
            <>
              <p style={{ color: 'var(--gray-600)', marginBottom: 'var(--space-xl)', textAlign: 'center' }}>
                4 comunidades espalhadas pelo território de Messejana e região. Clique para ver detalhes.
              </p>
              {loading ? (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 'var(--space-xl)', alignItems: 'stretch' }}>
                  {[1,2,3,4,5,6].map(i => <SkeletonCard key={i} />)}
                </div>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 'var(--space-xl)', alignItems: 'stretch' }}>
                  {lista.map(c => <ComunidadeCard key={c.id} capela={c} onClick={setModalCapela} />)}
                </div>
              )}
            </>
          )}

          {aba === 'pastorais' && (
            <>
              <p style={{ color: 'var(--gray-600)', marginBottom: 'var(--space-xl)', textAlign: 'center' }}>{PASTORAIS.length} pastorais a serviço da evangelização e do cuidado da comunidade.</p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'var(--space-lg)' }}>
                {PASTORAIS.map(p => <GrupoCard key={p.nome} {...p} />)}
              </div>
            </>
          )}

          {aba === 'movimentos' && (
            <>
              <p style={{ color: 'var(--gray-600)', marginBottom: 'var(--space-xl)', textAlign: 'center' }}>{MOVIMENTOS.length} movimentos de espiritualidade e apostolado presentes na paróquia.</p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'var(--space-lg)' }}>
                {MOVIMENTOS.map(m => <GrupoCard key={m.nome} {...m} />)}
              </div>
            </>
          )}

        </div>
      </section>
    </main>
  );
};

export default Capelas;